import React from "react";
import { ChartContainer, Subtitle, Title, TitleWrapper } from "./index.styled";
import CbsaCancerLineChart from "../../graph/cbsaCancerLineChart";

const FactSheetChart = ({ data, cbsa }) => {
  const formatCbsa = (text) => {
    if (text) {
      let [cbsaNumber, cbsaName] = text?.split(" - ");
      return cbsaName ? `${cbsaName} - ${cbsaNumber}` : cbsaNumber;
    }
  };
  const cbsaName = formatCbsa(cbsa);

  return (
    <ChartContainer>
      <TitleWrapper>
        <Title>{cbsaName}</Title>
        {data && <Subtitle>Estimated Case Density in CBSA </Subtitle>}
        {/* <Subtitle>Est. Annual Cancer Cases: 2025 - 35</Subtitle> */}
        {/* <Subtitle>--/--</Subtitle> */}
      </TitleWrapper>
      {data && <CbsaCancerLineChart data={data} />}
      {!data && <Subtitle style={{ color: "#cf6c58", fontWeight: "600" }}>No Cancer Incidences Data available </Subtitle>}
    </ChartContainer>
  );
};

export default FactSheetChart;
